module.exports = __webpack_public_path__ + "img/extended.d0dab64b.png";